import * as api from '../../../api/Api';

import { Dispatch } from 'redux';

import Constants from './constants';

const saveSettings = (team:string, settings:object) => async (dispatch:Dispatch) => {
    dispatch(createSavePending(settings));

    const response = await api.saveSettings(team, settings);

    dispatch(createSaveSuccess(response.settings));
}

const updateSettings = (settings:object) => (dispatch:Dispatch) => {
    dispatch(createUpdateSettings(settings));
};

const createSavePending = (settings:object) => ({
    settings,
    type: Constants.SAVE_SETTINGS_PENDING,
});

const createSaveSuccess = (settings:object) =>  ({
    settings,
    type: Constants.SAVE_SETTINGS_SUCCESS,
});

const createUpdateSettings = (settings:object) => ({
    settings,
    type: Constants.UPDATE_SETTINGS
});

export default {
    saveSettings,
    updateSettings,
};



// WEBPACK FOOTER //
// ./src/redux/modules/settings/actions.ts